"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Inbox_exports = {};
__export(Inbox_exports, {
  default: () => Inbox_default
});
module.exports = __toCommonJS(Inbox_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6016 6.07031C14.5234 5.90104 14.4128 5.77083 14.2695 5.67969C14.1393 5.58854 13.9896 5.54297 13.8203 5.54297H7.17969C7.01042 5.54297 6.85417 5.58854 6.71094 5.67969C6.58073 5.77083 6.47656 5.90104 6.39844 6.07031L4.71875 10.7969H7.70703C7.79818 10.7969 7.88281 10.8164 7.96094 10.8555C8.03906 10.8945 8.09766 10.9531 8.13672 11.0312L9.38672 12.75H11.6133L12.8633 11.0312C12.9023 10.9531 12.9609 10.8945 13.0391 10.8555C13.1172 10.8164 13.2018 10.7969 13.293 10.7969H16.2812L14.6016 6.07031ZM16.7695 12.0273H13.5664L12.3359 13.8242C12.2839 13.9023 12.2188 13.9609 12.1406 14C12.0625 14.0391 11.9779 14.0586 11.8867 14.0586H9.11328C9.02214 14.0586 8.9375 14.0391 8.85938 14C8.78125 13.9609 8.71615 13.9023 8.66406 13.8242L7.43359 12.0273H4.23047C4.21745 12.0273 4.21094 12.0273 4.21094 12.0273C4.21094 12.0273 4.20443 12.0273 4.19141 12.0273L4.05469 12.3008V14.9375C4.05469 15.1719 4.13932 15.3737 4.30859 15.543C4.47786 15.7122 4.67969 15.7969 4.91406 15.7969H16.0859C16.3203 15.7969 16.5221 15.7122 16.6914 15.543C16.8607 15.3737 16.9453 15.1719 16.9453 14.9375V12.3008L16.8086 12.0273C16.7956 12.0273 16.7891 12.0273 16.7891 12.0273C16.7891 12.0273 16.7826 12.0273 16.7695 12.0273ZM5.46094 5.5625C5.61719 5.21094 5.85156 4.93099 6.16406 4.72266C6.47656 4.51432 6.8151 4.41016 7.17969 4.41016H13.8203C14.1849 4.41016 14.5234 4.51432 14.8359 4.72266C15.1484 4.93099 15.3828 5.21094 15.5391 5.5625L17.9414 11.5586C17.9674 11.5977 17.9805 11.6432 17.9805 11.6953C17.9935 11.7344 18 11.7734 18 11.8125V14.8594C18 15.4193 17.8112 15.901 17.4336 16.3047C17.056 16.7083 16.6068 16.9102 16.0859 16.9102H4.91406C4.39323 16.9102 3.94401 16.7083 3.56641 16.3047C3.1888 15.901 3 15.4193 3 14.8594V11.8125C3 11.7734 3 11.7344 3 11.6953C3.01302 11.6432 3.03255 11.5977 3.05859 11.5586L5.46094 5.5625Z",
      fill: "currentColor"
    }
  )
);
const SvgInbox = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Inbox_default = SvgInbox;
